import { useEffect, useState } from 'react'
import { ChevronUp } from 'lucide-react'

const VISIBILITY_THRESHOLD = 500

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const updateVisibility = () => setVisible(window.scrollY >= VISIBILITY_THRESHOLD)
    updateVisibility()
    window.addEventListener('scroll', updateVisibility, { passive: true })
    return () => window.removeEventListener('scroll', updateVisibility)
  }, [])

  if (!visible) return null

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-24 right-3 z-40 flex h-11 w-11 items-center justify-center rounded-md border border-gray-200 bg-white/95 text-gray-700 shadow-lg backdrop-blur hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:border-gray-700 dark:bg-gray-800/95 dark:text-gray-100 dark:hover:bg-gray-700 sm:right-4"
      aria-label="Наверх"
      title="Наверх"
    >
      <ChevronUp className="h-5 w-5" />
    </button>
  )
}
